// A whole number as a Roman numeral. The cue writes the turn this way, so it
// does not read as a count of energy or a cost, which are digits.

const NUMERALS: readonly (readonly [number, string])[] = [
  [1000, 'M'],
  [900, 'CM'],
  [500, 'D'],
  [400, 'CD'],
  [100, 'C'],
  [90, 'XC'],
  [50, 'L'],
  [40, 'XL'],
  [10, 'X'],
  [9, 'IX'],
  [5, 'V'],
  [4, 'IV'],
  [1, 'I'],
];

/** A number of 1 or more as a Roman numeral. Zero or less gives an empty string. */
export const toRoman = (value: number): string => {
  let rest = Math.floor(value);
  let numeral = '';
  for (const [size, letters] of NUMERALS) {
    while (rest >= size) {
      numeral += letters;
      rest -= size;
    }
  }
  return numeral;
};
